import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../ui/Logo.jsx";
import { useCategoriesAPI } from "../../hooks/useCategoriesAPI.js";

const MobileNavigation = ({ isOpen, onClose }) => {
  const location = useLocation().pathname;
  const [expandedMenus, setExpandedMenus] = useState({
    solutions: false,
    about: false,
  });
  
  // Get categories from API
  const { categories, loading: categoriesLoading } = useCategoriesAPI();
  
  // Get parent categories (no parent_id)
  const parentCategories = categories.filter(cat => !cat.parent_id);

  if (!isOpen) return null;

  const toggleMenu = (menu) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };
  return (
    <div className="fixed inset-0 z-[1001] bg-white overflow-y-auto">
      <div className="min-h-screen flex flex-col">
        {/* Mobile Menu Header */}        <div className="p-4 h-16 border-b border-gray-100 flex justify-between items-center">
          <Logo 
            isWhite={false} 
            height={32} 
            onClick={onClose}
          />{" "}
          <button
            className="p-2 text-gray-500 rounded-full hover:bg-gray-100 focus:outline-none transition-colors duration-300"
            onClick={onClose}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            </svg>
          </button>
        </div>

        {/* Navigation Links */}
        <nav className="flex-grow py-6 px-4">
          <div className="space-y-0.5">
            {" "}
            <Link
              to="/"
              className={`block py-3.5 px-3 rounded-lg transition-colors duration-300 ${
                location === "/"
                  ? "bg-primary-50 text-primary"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
              onClick={onClose}
            >
              Home
            </Link>
            {/* Solutions Dropdown */}
            <div className="mt-0.5">
              {" "}
              <button
                className={`flex justify-between items-center w-full py-3.5 px-3 rounded-lg transition-colors duration-300 ${
                  location.startsWith("/solutions") || expandedMenus.solutions
                    ? "bg-primary-50 text-primary"
                    : "text-gray-700 hover:bg-gray-50"
                }`}
                onClick={() => toggleMenu("solutions")}
              >
                <span className="font-medium">Solutions</span>
                <svg
                  className={`w-5 h-5 transition-transform ${
                    expandedMenus.solutions ? "transform rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
              </button>
              {expandedMenus.solutions && (
                <div className="pl-4 mt-0.5 mb-0.5 space-y-0.5">
                  {parentCategories.length > 0 ? (
                    parentCategories.map((category) => (
                      <Link
                        key={category._id}
                        to={`/solutions?filter=${encodeURIComponent(category.name)}`}
                        className={`block py-3 px-3 rounded-lg transition-colors duration-300 ${
                          location === `/solutions?filter=${encodeURIComponent(category.name)}`
                            ? "bg-primary-50 text-primary"
                            : "text-gray-600 hover:bg-gray-50"
                        }`}
                        onClick={onClose}
                      >
                        {category.name}
                      </Link>
                    ))
                  ) : (
                    <div className="py-3 px-3 text-gray-500 text-sm">
                      {categoriesLoading ? 'Loading...' : 'No categories available'}
                    </div>
                  )}
                </div>
              )}
            </div>
            {/* About Us Dropdown */}
            <Link
              to="/about"
              className={`block py-3.5 px-3 rounded-lg transition-colors duration-300 ${
                location.startsWith("/portfolio")
                  ? "bg-primary-50 text-primary"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
              onClick={onClose}
            >
              About Us
            </Link>
            <Link
              to="/portfolio"
              className={`block py-3.5 px-3 rounded-lg transition-colors duration-300 ${
                location.startsWith("/portfolio")
                  ? "bg-primary-50 text-primary"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
              onClick={onClose}
            >
              Portfolio
            </Link>
            <Link
              to="/news"
              className={`block py-3.5 px-3 rounded-lg transition-colors ${
                location.startsWith("/news")
                  ? "bg-primary-50 text-primary"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
              onClick={onClose}
            >
              News
            </Link>
            <Link
              to="/contact"
              className={`block py-3.5 px-3 rounded-lg transition-colors ${
                location.startsWith("/contact")
                  ? "bg-primary-50 text-primary"
                  : "text-gray-700 hover:bg-gray-50"
              }`}
              onClick={onClose}
            >
              Contact
            </Link>
          </div>
        </nav>

        {/* Bottom Actions */}
        <div className="border-t border-gray-100 p-4 space-y-3">
          <Link
            to="/contact"
            className="flex justify-center items-center bg-accent hover:bg-accent-600 text-white font-medium py-3 px-4 rounded-lg w-full transition-colors"
            onClick={onClose}
          >
            Get a Quote
          </Link>

          <div className="flex gap-3">
            <a
              href="tel:+123456789"
              className="flex-1 flex justify-center items-center bg-primary hover:bg-primary-600 text-white font-medium py-3 px-4 rounded-lg transition-colors"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                ></path>
              </svg>
              Call
            </a>
            <a
              href="mailto:info@onepoint.com"
              className="flex-1 flex justify-center items-center bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-3 px-4 rounded-lg transition-colors"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                ></path>
              </svg>
              Email
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileNavigation;
